import { LinkText } from '@components/LinkText';
import { Pagination } from '@components/Table/Pagination';
import { TableCellAction } from '@components/Table/TableCellAction';
import { TableHeaderCellAction } from '@components/Table/TableHeaderCellAction';
import { TableLinearLoading } from '@components/Table/TableLinearLoading';
import { TableNoResult } from '@components/Table/TableNoResult';
import { TableSortCell } from '@components/Table/TableSortCell';
import { TableSortRow } from '@components/Table/TableSortRow';
import { TableWrapper } from '@components/Table/TableWrapper';
import { useCellPopover } from '@hooks/useCellPopover';
import { IData } from '@hooks/useData';
import useFormatter from '@hooks/useFormatter';
import { IMenu } from '@hooks/useMenu';
import { TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { IContratoCliente } from '@model/ContratoCliente';
import { useContratoClienteStatusColor } from '@model/ContratoClienteStatus';
import { IContratoClienteFilter } from '@services/ContratoClienteService';
import React from 'react';
import { ContratoClienteCanceladoPopover } from './ContratoClienteCanceladoPopover';

export type ContratoClienteTableProps = {
    data: IData<IContratoCliente, IContratoClienteFilter>
    isLoading: boolean
    menu: IMenu
}

export function ContratoClienteTable ({ data, isLoading, menu }: ContratoClienteTableProps) {
    const formatter = useFormatter();
    const contratoClienteStatusColor = useContratoClienteStatusColor();
    const cellPopover = useCellPopover<IContratoCliente>();

    return (
        <React.Fragment>
            <TableWrapper>
                <TableLinearLoading isLoading={isLoading} />
                <TableNoResult itemCount={data.itemsCount}>
                    <TableHead>
                        <Pagination pagination={data.pagination} />

                        <TableSortRow sort={data.sort}>
                            <TableSortCell fieldName="contratoClienteId">ID</TableSortCell>
                            <TableSortCell fieldName="clienteNome">Cliente</TableSortCell>
                            <TableSortCell fieldName="clienteCpf">Documento</TableSortCell>
                            <TableSortCell fieldName="linhaNumero">Nº da Linha</TableSortCell>
                            <TableSortCell fieldName="linhaNumeroContrato">Nº Contrato</TableSortCell>
                            <TableSortCell fieldName="linhaContratoOperadoraOperadoraNome">Operadora</TableSortCell>
                            <TableSortCell fieldName="linhaContratoOperadoraEmpresaNome">Empresa</TableSortCell>
                            <TableSortCell fieldName="inicio">Início</TableSortCell>
                            <TableSortCell fieldName="valorPlano">Vlr. Plano</TableSortCell>
                            <TableSortCell fieldName="usuarioLinha">Usuário da Linha</TableSortCell>
                            <TableSortCell fieldName="contratoClienteStatusNome">Status</TableSortCell>
                            <TableHeaderCellAction />
                        </TableSortRow>
                    </TableHead>
                    
                    <TableBody>
                        {
                            data.items.map((contratoCliente, index) => {
                                return (
                                    <TableRow key={index}>
                                        <TableCell><strong>{contratoCliente.contratoClienteId}</strong></TableCell>
                                        <TableCell><LinkText text={contratoCliente.clienteNome} to={`/cliente/${contratoCliente.clienteId}`} /></TableCell>
                                        <TableCell>{contratoCliente.clienteCpf}</TableCell>
                                        <TableCell>{formatter.toCelular(contratoCliente.linhaNumero)}</TableCell>
                                        <TableCell>{contratoCliente.linhaNumeroContrato}</TableCell>
                                        <TableCell>{contratoCliente.linhaContratoOperadoraOperadoraNome}</TableCell>
                                        <TableCell>{contratoCliente.linhaContratoOperadoraEmpresaNome}</TableCell>
                                        <TableCell>{formatter.toDate(contratoCliente.inicio)}</TableCell>
                                        <TableCell>{formatter.toFloat(contratoCliente.valorPlano)}</TableCell>
                                        <TableCell>{contratoCliente.usuarioLinha}</TableCell>
                                        
                                        <TableCell 
                                            className={contratoClienteStatusColor[contratoCliente.contratoClienteStatusId]}
                                            onMouseEnter={cellPopover.handleMouseOpen(contratoCliente)}
                                            onMouseLeave={cellPopover.close}
                                        >
                                            { contratoCliente.contratoClienteStatusNome }
                                        </TableCell>

                                        <TableCellAction onButtonClick={data.handleRowFocused(contratoCliente, menu.open)} />
                                    </TableRow>
                                )
                            })
                        }

                        <Pagination pagination={data.pagination} />

                    </TableBody>
                </TableNoResult>
            </TableWrapper>

            {
                cellPopover.record !== undefined && cellPopover.record.dataCancelamento !== undefined && (
                    <ContratoClienteCanceladoPopover cellPopover={cellPopover} contratoCliente={cellPopover.record} />
                )
            }
        </React.Fragment>
    )
}